/*
 * BestyBuys - Buy buttons effects (Add to cart + Buy it now).
 * Only loaded when a repeating animation or "Pop in" is picked in the Theme Editor.
 * Reads everything from data attributes on .bb-btns (timing, repeat count, which effect),
 * so nothing is fixed here. Repeating effects play only while the buttons are on screen,
 * stop after the chosen number of repeats (or never stop when "Keep moving all the time" is on,
 * data-fx-loop), and never run for visitors who prefer reduced motion.
 */
(function () {
  'use strict';
  if (window.bbBuyBtnFx) return;
  window.bbBuyBtnFx = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var LOOPS = { pulse: 1, glow: 1, ripple: 1, shine: 1, bounce: 1, wiggle: 1, tilt: 1, pulse_tilt: 1 };
  var KINDS = ['atc', 'bn'];

  function whenVisible(el, onChange) {
    if (!('IntersectionObserver' in window)) {
      onChange(true);
      return null;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          onChange(entry.isIntersecting);
        });
      },
      { threshold: 0.4 }
    );
    io.observe(el);
    return io;
  }

  /* Keep moving: the class stays on while the buttons are on screen, the CSS repeats the effect with no pause */
  function keepMoving(wrap, kind) {
    var io = null;
    io = whenVisible(wrap, function (isVisible) {
      if (!document.body.contains(wrap)) {
        if (io) io.disconnect();
        return;
      }
      if (isVisible) wrap.classList.add('bb-run-' + kind);
      else wrap.classList.remove('bb-run-' + kind);
    });
  }

  function startLoop(wrap, kind, dur, gap, max) {
    var visible = false;
    var runs = 0;
    var timer = null;
    var io = null;

    function stop() {
      clearTimeout(timer);
      if (io) io.disconnect();
      wrap.classList.remove('bb-run-' + kind);
    }

    function tick() {
      if (!document.body.contains(wrap) || runs >= max) return stop();
      if (visible && !document.hidden) {
        runs += 1;
        wrap.classList.add('bb-run-' + kind);
        setTimeout(function () {
          wrap.classList.remove('bb-run-' + kind);
        }, dur + 60);
      }
      timer = setTimeout(tick, dur + gap);
    }

    io = whenVisible(wrap, function (isVisible) {
      var wasVisible = visible;
      visible = isVisible;
      if (isVisible && !wasVisible && !timer) timer = setTimeout(tick, 300);
    });
  }

  function setup(wrap) {
    if (wrap.bbFxReady) return;
    wrap.bbFxReady = true;

    var dur = (parseFloat(getComputedStyle(wrap).getPropertyValue('--bb-fx-dur')) || 1) * 1000;
    var gap = (parseFloat(wrap.getAttribute('data-fx-gap')) || 4) * 1000;
    var max = parseInt(wrap.getAttribute('data-fx-repeat'), 10) || 5;
    var loop = wrap.hasAttribute('data-fx-loop');

    KINDS.forEach(function (kind) {
      var fx = wrap.getAttribute('data-fx-' + kind);
      if (!fx) return;
      if (fx === 'pop_in') {
        var io = whenVisible(wrap, function (isVisible) {
          if (!isVisible) return;
          wrap.classList.add('bb-go-' + kind);
          if (io) io.disconnect();
        });
      } else if (LOOPS[fx]) {
        if (loop) keepMoving(wrap, kind);
        else startLoop(wrap, kind, dur, gap, max);
      }
    });
  }

  function init() {
    if (reduce) return;
    document.querySelectorAll('.bb-btns').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme Editor re-renders the section; a variant change swaps the buy box - set up the new buttons too */
  document.addEventListener('shopify:section:load', init);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      setTimeout(init, 80);
    });
  }
})();
